import { Component, Input, OnInit } from '@angular/core';
import * as fromRoot from '@app/reducers';
import { Customization } from '@app/shared/models/customization';
import { Device } from '@app/shared/models/device';
import { Promotion } from '@app/shared/models/promotion';
import { Store } from '@ngrx/store';
import { GoogleTagManagerService } from '@app/core/lib/google-tag-manager/angular-google-tag-manager.service';
import { merge, Observable, of } from 'rxjs';
import { delay, map, mapTo, withLatestFrom } from 'rxjs/operators';
import { Constant } from 'src/constant';
import * as fromViewer from '../reducers/viewer.reducer';
import { ThemeSimplified } from '@app/shared/helpers/theme';

@Component({
  selector: 'app-downloader',
  templateUrl: './downloader.component.html',
  styleUrls: ['./downloader.component.scss']
})
export class DownloaderComponent implements OnInit {

  @Input() device: Device;
  @Input() customization: Customization;

  promotion$: Observable<Promotion>;
  theme$: Observable<ThemeSimplified>;

  state = 'loadingNotStarted';
  hasPromotion = false;
  hasTheme = false;
  replay = false;
  promotionHeight: number;
  showOverlay: boolean;
  showVideo: boolean;
  progressAnimation = of(null);

  constructor(
    private store$: Store<fromRoot.State & fromViewer.State>,
    private gtmService: GoogleTagManagerService
  ) {
    this.promotion$ = this.store$.select(fromViewer.getPromotion);
    this.theme$ = this.store$.select(fromRoot.getTheme);

    this.promotion$.pipe(
      withLatestFrom(this.theme$),
    ).subscribe(([promotion, theme]) => {
      if (!!promotion) {
        this.hasPromotion = true;
        this.resolveLoadingState(this.progressAnimation);
        this.gtmService.pushTag({
          event: Constant.eventGTM.EXTERNAL_PROMOTION_DISPLAYED,
          promotion_title: promotion.title,
          promotion_id: promotion.id,
          promotion_target: promotion.target,
          promotion_link: promotion.link,
          promotion_language: promotion.language,
        });
      } else if (!!theme?.reveal) {
        this.hasTheme = true;
        this.resolveLoadingState(this.progressAnimation);
        this.gtmService.pushTag({
          event: Constant.eventGTM.DISPLAY_THEME_REVEAL,
          theme_id: theme.id,
          theme_name: theme.name,
        });

        // TO REMOVE: This is a temporary solution to keep tracking the old promotion display event
        this.gtmService.pushTag({
          event: Constant.eventGTM.EXTERNAL_PROMOTION_DISPLAYED,
          promotion_title: theme.name,
          promotion_id:  theme.name,
        });
      }
    });
  }

  ngOnInit(): void {
    if (this.customization) {
      this.showOverlay = true;
    }
  }

  isVideoBgReadyToPlay(event): void {
    this.showVideo = true;
  }

  private resolveLoadingState(progress: Observable<null>) {
    this.setAnimation(progress).subscribe((val: string) => {
      this.state = val;
      if (val === 'loadingFinished') {
        this.toggleTeaserMessage();
      }
    });
  }

  private setAnimation(progress: Observable<null>) {
    const message = merge(
      progress.pipe(
        mapTo('loadingStarted'),
        delay(100)
      ),
      progress.pipe(
        mapTo('loadingFinished'),
        delay(2500)
      )
    );
    return message;
  }

  private toggleTeaserMessage() {
    this.replay = true;
  }
}
